import React, { useState } from 'react'
import Accordion from '@mui/material/Accordion';
import SearchIcon from '@mui/icons-material/Search'
import faqImage from "../../../images/faq-image.png";
import SettingsIcon from '@mui/icons-material/Settings';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { InputAdornment, TextField } from '@mui/material';
import { darkModeBackgroud } from '../../../utils/constants';
import { useDarkModeStore } from '../../../store/useDarkModeStore';
import { useLanguageStore } from '../../../store/useLanguageStore';

interface Menu {
    id: number;
    name: string;
    icon: JSX.Element;
    items: { id: number, question: string, answer: string }[]

}

const stylecss = { width: 20, height: 20, marginRight: 1 };

const menu: Menu[] = [
    {
        id: 1,
        name: 'Payment',
        icon: <CreditCardIcon sx={stylecss} />,
        items: [
            {
                id: 1,
                question: 'Pyetja',
                answer: 'Pergjigja',
            }
        ]
    },
    {
        id: 2,
        name: 'Delivery',
        icon: <WorkOutlineIcon sx={stylecss} />,
        items: [
            {
                id: 1,
                question: 'Pyetja',
                answer: 'Pergjigja',
            }
        ]
    },
    {
        id: 3,
        name: 'Cancellation & Return',
        icon: <RotateLeftIcon sx={stylecss} />,
        items: [
            {
                id: 1,
                question: 'Pyetja',
                answer: 'Pergjigja',
            }
        ]
    },
    {
        id: 4,
        name: 'My Orders',
        icon: <ViewInArIcon sx={stylecss} />,
        items: [
            {
                id: 1,
                question: 'Pyetja',
                answer: 'Pergjigja',
            }
        ]
    },
    {
        id: 5,
        name: 'Product & Services',
        icon: <SettingsIcon sx={stylecss} />,
        items: [
            {
                id: 1,
                question: 'Pyetja',
                answer: 'Pergjigja',
            }
        ]
    },
];

export const FAQQuestions = () => {
    const { darkMode } = useDarkModeStore();
    const { language } = useLanguageStore();

    const [selectedCategory, setSelectedCategory] = useState<number>(1);

    const returnMenuItem = menu.find(item => item.id === selectedCategory);

    return (
        <React.Fragment>
            <div
                className='d-flex flex-column align-items-center justify-content-center mb-4'
                style={{ background: darkMode ? darkModeBackgroud : '#E9EAEE', padding: '30px 10px', borderRadius: 10 }}
            >
                <h3 className={`${darkMode && 'text-white'}`}>{language['HelpQuestion']}</h3>
                <p className={`${darkMode && 'text-white'}`}>{language['HelpCategory']}</p>

                <TextField
                    variant="outlined"
                    className='w-50 mt-3'
                    placeholder={`${language['Search']}...`}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon style={{ color: darkMode ? 'default' : '#8598BB' }} />
                            </InputAdornment>
                        ),
                        sx: {
                            '& .MuiOutlinedInput-root': {
                                borderColor: darkMode ? 'white' : 'default',
                            },
                            '& .MuiInputBase-input::placeholder': {
                                color: darkMode ? 'white' : 'rgba(0, 0, 0, 0.5)',
                                opacity: 1,
                            },
                            '& .MuiInputBase-input': {
                                color: darkMode ? 'white' : 'default',
                            },
                            '& .css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
                                borderColor: darkMode ? '#1976d2' : 'default'
                            }
                        },
                    }}
                />

            </div>
            <div className='d-flex flex-row gap-4 p-2 mt-3'>
                <div className='d-flex flex-column' style={{ gap: .7, width: 270 }}>
                    {
                        menu.map((item, index) =>
                            <span
                                key={item.id + index + '-menu'}
                                className={`faq-item ${darkMode && 'text-white'} ${item.id === selectedCategory && 'faq-item-active'}`}
                                onClick={() => setSelectedCategory(item.id)}
                            >
                                {item.icon} {item.name}
                            </span>

                        )
                    }
                    <img src={faqImage} alt="Faq Image" style={{ width: 230, height: 160 }} className='mt-3' />
                </div>
                <div className='w-75 d-flex flex-column gap-2'>
                    <div className='d-flex flex-row gap-2'>
                        <div className="d-flex align-items-center justify-content-center" style={{ width: 50, height: 50, background: '#DFDFFA', borderRadius: 5 }}>
                            {menu?.find(item => item.id === selectedCategory)?.icon &&
                                React.isValidElement(returnMenuItem?.icon) ?
                                React.cloneElement(returnMenuItem?.icon as React.ReactElement, { sx: { width: 30, height: 30, color: '#696CFF' } })
                                : ''
                            }
                        </div>
                        <div className="d-flex flex-column gap-1">
                            <span className={`${darkMode && 'text-white'}`}>{returnMenuItem?.name ?? ''}</span>
                            <p className={`${darkMode ? 'text-white' : 'text-muted'}`} style={{ fontSize: 14 }}>Get help with {returnMenuItem?.name}</p>
                        </div>
                    </div>
                    <div className='d-flex flex-column'>
                        {[1, 2, 3, 4, 5].map((item, index) =>
                            <Accordion
                                key={index + '-accordion'}
                                className='mb-2'
                                style={{ borderRadius: '5px', background: darkMode ? 'var(--dark-mode-bg)' : 'white' }}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls={`panel${item}-content`}
                                    id={`panel${item}-header`}
                                    className={`${darkMode && 'text-white'}`}
                                >
                                    Accordion 1
                                </AccordionSummary>
                                <AccordionDetails className={`${darkMode ? 'text-white' : 'default'}`}>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                                    malesuada lacus ex, sit amet blandit leo lobortis eget.
                                </AccordionDetails>
                            </Accordion>
                        )}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
export default FAQQuestions